import styled, { css } from 'styled-components/macro'
import { switchProp, ifNotProp } from 'styled-tools'
import { rem } from '../../utils/styles'

const align = switchProp('align', {
  left: 'left',
  center: 'center',
  right: 'right'
}, 'left')
const vAlign = switchProp('vAlign', {
  top: 'top',
  center: 'middle',
  bottom: 'bottom'
}, 'middle')
const expanded = ifNotProp('expanded', css`
  border-bottom: 1px solid;
`, css`
  padding-bottom: 0;
`)

const TableCell = styled.td`
  padding: ${rem(8)} ${rem(12)};
  text-align: ${align};
  vertical-align: ${vAlign};
  ${expanded}
`

export default TableCell
